// Taban Mobilya Atölyesi — cost & CNC calculation utilities
// All dimensions in centimeters. Prices in TRY (₺).
// Renkler ve kapak modelleri Kastamonu Entegre kataloglarından alınmıştır
// (Vision melamin kaplı panel + Glossmax / Glossmax Pro serileri).

// ---- Gövde malzemesi (m² başına üretim maliyeti) ----
export const BODY_MATERIALS = [
  { id: "suntalam", label: "Suntalam", price: 7000 },
  { id: "mdf", label: "MDF", price: 7500 },
];

// ---- Kapak modeli (m² başına üretim maliyeti) ----
export const DOOR_MATERIALS = [
  {
    id: "suntalam",
    label: "Suntalam",
    price: 6500,
    gloss: 0.72,
    texture: "https://images.unsplash.com/photo-1604147706283-d7119b5b822c?crop=entropy&cs=srgb&fm=jpg&q=85&w=512",
  },
  {
    id: "mdf",
    label: "MDF (Mat)",
    price: 7500,
    gloss: 0.62,
    texture: "https://images.unsplash.com/photo-1604147706283-d7119b5b822c?crop=entropy&cs=srgb&fm=jpg&q=85&w=512",
  },
  {
    id: "highgloss",
    label: "High Gloss",
    price: 8000,
    gloss: 0.14,
    texture: "https://static.prod-images.emergentagent.com/jobs/297a8bc7-7df9-44fd-bc49-34e7eb847333/images/6aa3eb61bd2454d66e43affec105bd92dd8e6d112bd52af4270282b30a331e35.jpeg",
  },
  {
    id: "akrilik",
    label: "Akrilik",
    price: 8500,
    gloss: 0.06,
    texture: "https://static.prod-images.emergentagent.com/jobs/297a8bc7-7df9-44fd-bc49-34e7eb847333/images/4a67986cbeb5d55e6fe0ece44c6faf9c7db527bcecc0ff926904e51eb6b84c80.jpeg",
  },
  {
    id: "cam",
    label: "Cam (Siyah Alüminyum)",
    price: 9500,
    gloss: 0.08,
    texture: null,
  },
  {
    id: "ayna",
    label: "Ayna",
    price: 9500,
    gloss: 0.05,
    texture: null,
  },
];

// ---- Gövde renkleri — Kastamonu Entegre Vision koleksiyonu ----
// Kastamonu Entegre ahşap desen dokuları (wood-look decor)
const T_SONOMA = "https://static.prod-images.emergentagent.com/jobs/297a8bc7-7df9-44fd-bc49-34e7eb847333/images/8e7000811d089a8b16b60421f1e41d544e08657d0fcc2946bca95f47c5d7a6f0.jpeg";
const T_WALNUT = "https://static.prod-images.emergentagent.com/jobs/297a8bc7-7df9-44fd-bc49-34e7eb847333/images/853824789d277196060b826245160f8229a034bbc79742ceb6747555a1ff04da.jpeg";
const T_ANTHRA = "https://static.prod-images.emergentagent.com/jobs/297a8bc7-7df9-44fd-bc49-34e7eb847333/images/d98cd5c8225a349bd450319b83acfee4a3565bb683e6eb7a9d7755a7f37b44f9.jpeg";

// ---- Düz (solid) dekorlar — Kastamonu Entegre Vision / Glossmax ----
const SOLID_COLORS = [
  { id: "d175", code: "D175", label: "Süper Beyaz", hex: "#F7F7F5" },
  { id: "d215", code: "D215", label: "Arktik Beyaz", hex: "#EDEDEA" },
  { id: "d129", code: "D129", label: "Lake Beyaz", hex: "#F0EFEA" },
  { id: "d152", code: "D152", label: "Opak Beyaz", hex: "#F5F4F0" },
  { id: "d214", code: "D214", label: "Porselen Beyaz", hex: "#F2F0EC" },
  { id: "d102", code: "D102", label: "Bej", hex: "#D9C7A6" },
  { id: "d162", code: "D162", label: "Sedef", hex: "#E4DED2" },
  { id: "d140", code: "D140", label: "Kumtaşı", hex: "#C8BFA8" },
  { id: "d160", code: "D160", label: "Aytaşı", hex: "#C4BCB0" },
  { id: "d216", code: "D216", label: "Latte", hex: "#D6C6B0" },
  { id: "d218", code: "D218", label: "Kaşmir", hex: "#D9CDBE" },
  { id: "d270", code: "D270", label: "Pudra", hex: "#E7C9C2" },
  { id: "d290", code: "D290", label: "Mint", hex: "#BFD8CC" },
  { id: "d280", code: "D280", label: "Lavanta", hex: "#A99FC0" },
  { id: "d260", code: "D260", label: "Hardal", hex: "#C79A3B" },
  { id: "d251", code: "D251", label: "Kiremit", hex: "#B5623F" },
  { id: "d126", code: "D126", label: "Cappuccino", hex: "#A08060" },
  { id: "d145", code: "D145", label: "Bronz", hex: "#6E5B45", dark: true },
  { id: "d123", code: "D123", label: "Açık Gri", hex: "#C7C7C4" },
  { id: "d217", code: "D217", label: "Buz Gri", hex: "#C9CCCF" },
  { id: "d141", code: "D141", label: "Kül Gri", hex: "#9A9B98" },
  { id: "d161", code: "D161", label: "Dafne", hex: "#7E8B94", dark: true },
  { id: "d240", code: "D240", label: "Fıstık Yeşili", hex: "#7C8C5A", dark: true },
  { id: "d241", code: "D241", label: "Zümrüt", hex: "#2E5D50", dark: true },
  { id: "d230", code: "D230", label: "Pasifik Mavi", hex: "#3A5A6B", dark: true },
  { id: "d231", code: "D231", label: "Gece Mavisi", hex: "#2B3A55", dark: true },
  { id: "d250", code: "D250", label: "Bordo", hex: "#6E2B2E", dark: true },
  { id: "d143", code: "D143", label: "Antrasit", hex: "#383B3E", dark: true },
  { id: "d188", code: "D188", label: "Deep", hex: "#2C2E33", dark: true },
  { id: "d107", code: "D107", label: "Siyah", hex: "#1D1D1B", dark: true },
  { id: "d186", code: "D186", label: "Piyano Siyah", hex: "#141414", dark: true },
];

// ---- Ahşap desenli dekorlar (3D'de damar dokusuyla) ----
const WOOD_COLORS = [
  { id: "pr250", code: "PR250", label: "Doğal Meşe", hex: "#C8A97E", tex: T_SONOMA },
  { id: "ar120", code: "AR120", label: "Sonoma Meşe", hex: "#C9B79C", tex: T_SONOMA },
  { id: "pr121", code: "PR121", label: "Bardolino Meşe", hex: "#B79E7C", tex: T_SONOMA },
  { id: "ar490", code: "AR490", label: "Ceviz", hex: "#6B4A2F", tex: T_WALNUT, dark: true },
  { id: "ar803", code: "AR803", label: "Wenge", hex: "#4A3728", tex: T_WALNUT, dark: true },
  { id: "pr118", code: "PR118", label: "Antrasit Meşe", hex: "#3B3A38", tex: T_ANTHRA, dark: true },
];

export const BODY_COLORS = [...SOLID_COLORS, ...WOOD_COLORS];
export const DOOR_COLORS = [...SOLID_COLORS, ...WOOD_COLORS];

// ---- Cam kapak renkleri (siyah alüminyum çerçeveli cam kapak) ----
export const GLASS_COLORS = [
  { id: "cam_seffaf", code: "CAM", label: "Şeffaf", hex: "#C9D6DA" },
  { id: "cam_fume_acik", code: "CAM", label: "Füme Açık", hex: "#8B9498", dark: true },
  { id: "cam_fume_koyu", code: "CAM", label: "Füme Koyu", hex: "#3B4246", dark: true },
];

export function bodyMaterialById(id) {
  return BODY_MATERIALS.find((m) => m.id === id) || BODY_MATERIALS[0];
}
export function doorMaterialById(id) {
  return DOOR_MATERIALS.find((m) => m.id === id) || DOOR_MATERIALS[0];
}
export function bodyColorById(id) {
  return BODY_COLORS.find((c) => c.id === id) || BODY_COLORS[0];
}
export function doorColorById(id) {
  return (
    DOOR_COLORS.find((c) => c.id === id) ||
    GLASS_COLORS.find((c) => c.id === id) ||
    DOOR_COLORS[0]
  );
}

// 3D görünüm için zenginleştirilmiş config (renk hex'leri, dokular, etiketler)
export function enrich3dConfig(cfg) {
  const body = bodyColorById(cfg.bodyColor);
  const door = doorColorById(cfg.doorColor);
  const bodyMat = bodyMaterialById(cfg.bodyMaterial);
  const doorMat = doorMaterialById(cfg.doorMaterial);
  return {
    ...cfg,
    bodyHex: body.hex,
    doorHex: door.hex,
    bodyColorLabel: `${body.code} ${body.label}`,
    doorColorLabel: `${door.code} ${door.label}`,
    bodyMaterialLabel: bodyMat.label,
    doorMaterialLabel: doorMat.label,
    doorGloss: doorMat.gloss,
    doorTexture: doorMat.texture,
    bodyColorTex: body.tex,
    doorColorTex: door.tex,
  };
}


// Pricing constants (defaults; overridable by admin via /api/prices)
export const DEFAULT_PRICES = {
  body: { suntalam: 7000, mdf: 7500 },
  door: { suntalam: 6500, mdf: 7500, highgloss: 8000, akrilik: 8500 },
  backPanel: 180, // ₺/m² (8mm arka panel)
  edgeBand: 14, // ₺/m
  hinge: 45, // ₺ per hinge (2 per door)
  handle: 65, // ₺ per handle (1 per door)
  cncRate: 240, // ₺/m² işleme
  assemblyBase: 350, // ₺ sabit montaj
  drawerRail: 120, // ₺/çekmece ray aksesuarı
  legUnit: 35, // ₺/ayak
};

export const SHEET_W = 280; // cm (2.80 m)
export const SHEET_H = 210; // cm (2.10 m)
const GAP = 0; // parçalar arasında boşluk yok

// Kapak parçalama: split = üst+alt, split3 = üst+orta+alt (alttan üste sıralı, ölçüler cm)
export function doorSegments(H, layout) {
  if (layout === "split3") {
    const topH = Math.min(60, H * 0.3);
    const segH = (H - 0.6 - topH) / 2;
    return [
      { suffix: " Alt", h: segH },
      { suffix: " Orta", h: segH },
      { suffix: " Üst", h: topH },
    ];
  }
  if (layout === "split") {
    const topH = Math.min(60, H * 0.35);
    return [
      { suffix: " Alt", h: H - 0.6 - topH },
      { suffix: " Üst", h: topH },
    ];
  }
  return [{ suffix: "", h: H - 0.6 }];
}

// Raf yerleşimi (iç tabandan itibaren raf merkezleri, cm) + yapısal bilgisi.
// Parçalı kapakta bölme rafları kapak bitimlerine hizalanır (structural: true, kaldırılamaz);
// kalan raflar segment içlerine orantısal dağıtılır (structural: false, kaldırılabilir).
export function shelfLayoutDetailed(cfg) {
  const H = cfg.height;
  const T_CM = 3; // panel kalınlığı
  const n = cfg.shelves ?? 0;
  const drawerSection =
    (cfg.drawers ?? 0) > 0 ? cfg.drawers * ((cfg.drawerHeight ?? 20) + 1) + T_CM : 0;
  const interiorH = H - 2 * T_CM;
  const splitActive =
    !cfg.doorless &&
    cfg.doorStyle !== "flap" &&
    (cfg.doorLayout === "split" || cfg.doorLayout === "split3");

  if (!splitActive) {
    return Array.from({ length: n }, (_, i) => ({
      y: drawerSection + ((interiorH - drawerSection) * (i + 1)) / (n + 1),
      structural: false,
    }));
  }

  const segs = doorSegments(H, cfg.doorLayout); // alttan üste
  const bounds = [];
  let acc = 0.5; // kapak alt kenar payı
  for (let k = 0; k < segs.length - 1; k++) {
    acc += segs[k].h;
    bounds.push(Math.max(acc - T_CM, drawerSection + 2));
  }
  const total = Math.max(n, bounds.length);
  const extra = total - bounds.length;

  // Segment serbest aralıkları: [önceki sınır/çekmece üstü, sonraki sınır/iç üst]
  const starts = [drawerSection, ...bounds.map((b) => b + T_CM / 2)];
  const ends = [...bounds.map((b) => b - T_CM / 2), interiorH];
  const free = segs.map((_, i) => Math.max(0, ends[i] - starts[i]));
  const freeSum = free.reduce((s, f) => s + f, 0);

  const extras = free.map((f) => (freeSum > 0 ? Math.floor((extra * f) / freeSum) : 0));
  let left = extra - extras.reduce((s, e) => s + e, 0);
  const order = free.map((f, i) => [f, i]).sort((a, b) => b[0] - a[0]).map((x) => x[1]);
  for (let k = 0; left > 0 && k < order.length; k++, left--) extras[order[k]]++;

  const tagged = bounds.map((y) => ({ y, structural: true }));
  segs.forEach((_, i) => {
    for (let j = 0; j < extras[i]; j++) {
      tagged.push({
        y: starts[i] + ((ends[i] - starts[i]) * (j + 1)) / (extras[i] + 1),
        structural: false,
      });
    }
  });
  return tagged.filter((s) => s.y > 0 && s.y < interiorH).sort((a, b) => a.y - b.y);
}

export function shelfLayout(cfg) {
  return shelfLayoutDetailed(cfg).map((s) => s.y);
}

// Kaldırılmamış kapak kanatları (parça bazında). Her kanat: { i, k, key, h, suffix, flap }.
// key: tek parçalı/düşer kapakta "i", parçalı kapakta "i:k" (i=kapak sırası, k=segment).
export function doorUnits(cfg) {
  if (cfg.doorless) return [];
  const H = cfg.height;
  const flap = cfg.doorStyle === "flap";
  const layout = flap ? "full" : cfg.doorLayout;
  const segs = doorSegments(H, layout);
  const multi = segs.length > 1;
  const removed = new Set(cfg.removedDoors || []);
  const units = [];
  for (let i = 0; i < cfg.doors; i++) {
    segs.forEach((sg, k) => {
      const key = multi ? `${i}:${k}` : `${i}`;
      if (removed.has(key)) return;
      units.push({ i, k, key, h: sg.h, suffix: sg.suffix, flap });
    });
  }
  return units;
}

// Build the list of panels (in cm) for a wardrobe config.
export function buildPanels(cfg) {
  const { width: W, height: H, depth: D } = cfg;
  const doors = cfg.doorless ? 0 : cfg.doors;
  const dividers = cfg.dividers ?? 0;
  const body = bodyColorById(cfg.bodyColor);
  const door = doorColorById(cfg.doorColor);
  const panels = [];

  panels.push({ name: "Sol Yan", w: D, h: H, group: "body", color: body.hex });
  panels.push({ name: "Sağ Yan", w: D, h: H, group: "body", color: body.hex });
  panels.push({ name: "Üst Tabla", w: W - 3.6, h: D, group: "body", color: body.hex });
  panels.push({ name: "Alt Tabla", w: W - 3.6, h: D, group: "body", color: body.hex });

  for (let i = 0; i < dividers; i++) {
    // Dikme, alt kapama seçiliyse kapama yüksekliği kadar (8 cm) aşağı uzar.
    // Tabaka boyu max 280 cm olduğundan dikme ölçüsü 280 cm ile sınırlıdır.
    panels.push({
      name: `Orta Dikme ${i + 1}`,
      w: D,
      h: Math.min(H - 3.6 + (cfg.base === "alt_kapama" ? 8 : 0), 280),
      group: "body",
      color: body.hex,
    });
  }

  // Raflar bölme bazında ayrılır: dikme varsa her bölmenin rafı ayrı parça,
  // böylece müşteri yalnızca seçtiği bölmenin rafını kaldırabilir.
  const removedShelves = new Set((cfg.removedShelves || []).map(String));
  const shelfCols = dividers + 1;
  const shelfColW = (W - 3.6 - 1.8 * dividers) / shelfCols;
  shelfLayoutDetailed(cfg).forEach((s, i) => {
    for (let j = 0; j < shelfCols; j++) {
      if (!s.structural && removedShelves.has(`${i}:${j}`)) continue;
      panels.push({
        name: dividers > 0 ? `Raf ${i + 1}-${j + 1}` : `Raf ${i + 1}`,
        w: shelfColW,
        h: D - 2,
        group: "body",
        color: body.hex,
      });
    }
  });

  // Alt kapama (8 cm standart): yan parçalar gövde malzemesi/rengi,
  // ön orta parça kapak malzemesi/rengi ve kapak metrajına dahil.
  if (cfg.base === "alt_kapama") {
    panels.push({ name: "Alt Kapama Yan", w: D, h: 8, group: "body", color: body.hex });
    panels.push({ name: "Alt Kapama Yan", w: D, h: 8, group: "body", color: body.hex });
    // Cam veya ayna kapakta alt kapama önü gövde malzemesinden/renginden hesaplanır
    if (cfg.doorMaterial === "cam" || cfg.doorMaterial === "ayna") {
      panels.push({ name: "Alt Kapama Ön", w: W - 3.6, h: 8, group: "body", color: body.hex });
    } else {
      panels.push({ name: "Alt Kapama Ön", w: W - 3.6, h: 8, group: "door", color: door.hex });
    }
  }

  // Çekmeceler — orta dikmeye göre bölmelere ayrılır, her bölmede bağımsız çekmece
  const drawers = cfg.drawers ?? 0;
  const drawerHeight = cfg.drawerHeight ?? 20; // cm (ön panel yüksekliği)
  const wallH = drawerHeight - 6; // kutu duvar yüksekliği (ray payı)
  const numCols = dividers + 1;
  const colW = (W - 4 - dividers * 1.8) / numCols;
  for (let i = 0; i < drawers; i++) {
    for (let j = 0; j < numCols; j++) {
      const tag = numCols > 1 ? `${i + 1}-${j + 1}` : `${i + 1}`;
      panels.push({ name: `Çekmece Ön ${tag}`, w: colW, h: drawerHeight, group: "body", color: body.hex });
      panels.push({ name: `Çekmece Yan ${tag}`, w: D - 6, h: wallH, group: "body", color: body.hex });
      panels.push({ name: `Çekmece Yan ${tag}`, w: D - 6, h: wallH, group: "body", color: body.hex });
      panels.push({ name: `Çekmece Duvar ${tag}`, w: colW - 3, h: wallH, group: "body", color: body.hex });
      panels.push({ name: `Çekmece Duvar ${tag}`, w: colW - 3, h: wallH, group: "body", color: body.hex });
      panels.push({ name: `Çekmece Taban ${tag}`, w: colW - 3, h: D - 6, group: "body", color: body.hex });
      panels.push({ name: `Çekmece Üst ${tag}`, w: colW - 3, h: D - 6, group: "body", color: body.hex });
    }
  }

  const doorW = (W - (doors + 1) * 0.3) / doors;
  // Cam ve ayna kapaklar tabaka kesimine girmez (nocut) — ayrı temin edilir
  const noCutDoor = cfg.doorMaterial === "cam" || cfg.doorMaterial === "ayna" ? cfg.doorMaterial : null;
  doorUnits(cfg).forEach((u) => {
    panels.push({
      name: `Kapak ${u.i + 1}${u.suffix}`,
      w: doorW,
      h: u.h,
      group: "door",
      color: door.hex,
      ...(noCutDoor ? { nocut: true, nocutType: noCutDoor } : {}),
    });
  });

  return panels;
}

function areaM2(w, h) {
  return (w * h) / 10000; // cm² -> m²
}

export function computeCost(cfg, prices = DEFAULT_PRICES) {
  const p = prices || DEFAULT_PRICES;
  const bodyMat = bodyMaterialById(cfg.bodyMaterial);
  const doorMat = doorMaterialById(cfg.doorMaterial);
  const body = bodyColorById(cfg.bodyColor);
  const door = doorColorById(cfg.doorColor);
  const panels = buildPanels(cfg);

  const bodyPrice = (p.body && p.body[bodyMat.id]) ?? bodyMat.price;
  const doorPrice = (p.door && p.door[doorMat.id]) ?? doorMat.price;

  let bodyArea = 0;
  let doorArea = 0;
  let glassArea = 0; // cam kapak: ayrı fiyatlandırılır, kenar bandı/kesim yok
  let mirrorArea = 0; // ayna kapak: ayrı fiyatlandırılır, kenar bandı/kesim yok
  let edgeLen = 0; // meters
  panels.forEach((pn) => {
    const a = areaM2(pn.w, pn.h);
    if (pn.nocut) {
      if (pn.nocutType === "ayna") mirrorArea += a;
      else glassArea += a;
    }
    else if (pn.group === "door") doorArea += a;
    else bodyArea += a;
    if (!pn.nocut) edgeLen += (2 * (pn.w + pn.h)) / 100; // perimeter in meters
  });

  // Arka panel: kapaksız tasarımlarda müşteri arkalığı iptal edebilir
  const noBack = !!cfg.noBackPanel && !!cfg.doorless;
  const backArea = noBack ? 0 : areaM2(cfg.width, cfg.height);
  const totalProcessArea = bodyArea + doorArea + backArea;

  const items = [];
  items.push({
    label: "Gövde Malzemesi",
    detail: `${bodyMat.label} • ${body.code} ${body.label} • ${bodyArea.toFixed(2)} m²`,
    amount: bodyArea * bodyPrice,
  });
  const glass = cfg.doorMaterial === "cam";
  const mirror = cfg.doorMaterial === "ayna";
  const units = doorUnits(cfg);
  if (doorArea > 0) {
    const parts = [];
    if (!cfg.doorless && !glass && !mirror && units.length > 0) {
      const multiSeg =
        (cfg.doorLayout === "split" || cfg.doorLayout === "split3") && cfg.doorStyle !== "flap";
      parts.push(`${units.length} ${multiSeg ? "parça kapak" : "kapak"}`);
    }
    if (cfg.base === "alt_kapama") parts.push("alt kapama önü");
    items.push({
      label: "Kapak Malzemesi",
      detail: `${doorMat.label} • ${door.code} ${door.label} • ${parts.join(" + ")} • ${doorArea.toFixed(2)} m²`,
      amount: doorArea * doorPrice,
    });
  }
  // Cam kapak ayrı fiyatlandırılır (alüminyum çerçeve + cam; tabaka kesimine ve kenar bandına girmez)
  if (glassArea > 0) {
    const glassPrice = (p.door && p.door.cam) ?? 9500;
    items.push({
      label: "Cam Kapak (Siyah Alüminyum Çerçeveli)",
      detail: `${door.label} • ${units.length} kapak • ${glassArea.toFixed(2)} m²`,
      amount: glassArea * glassPrice,
    });
  }
  // Ayna kapak ayrı fiyatlandırılır (tabaka kesimine ve kenar bandına girmez; ayna tam kapak ölçüsünde)
  if (mirrorArea > 0) {
    const mirrorPrice = (p.door && p.door.ayna) ?? 9500;
    items.push({
      label: "Ayna Kapak",
      detail: `${units.length} kapak • ${mirrorArea.toFixed(2)} m²`,
      amount: mirrorArea * mirrorPrice,
    });
  }
  if (backArea > 0) {
    items.push({
      label: "Arka Panel",
      detail: `8mm • ${backArea.toFixed(2)} m²`,
      amount: backArea * p.backPanel,
    });
  }
  items.push({
    label: "Kenar Bandı",
    detail: `${edgeLen.toFixed(1)} m`,
    amount: edgeLen * p.edgeBand,
  });
  if (!cfg.doorless && units.length > 0) {
    // Menteşe/mekanizma kalan kapak kanatlarına göre hesaplanır (kaldırılanlar düşülür).
    const flap = units[0].flap;
    let hingeTotal = 0;
    units.forEach((u) => {
      hingeTotal += flap ? 2 : u.h > 240 ? 4 : u.h > 160 ? 3 : 2;
    });
    // Ayna kapaklar kulpsuzdur; düşer kapakta "bas-aç" seçilirse kulp olmaz
    const pushToOpen = flap && cfg.flapHandle === "push";
    const handleCount = mirror || pushToOpen ? 0 : units.length;
    const hingeDetail = flap
      ? `${units.length} kapak × 2 = ${hingeTotal} adet`
      : `${units.length} kapak • toplam ${hingeTotal} adet`;
    items.push({
      label: flap ? "Düşer Kapak Mekanizması" : "Menteşe",
      detail: hingeDetail,
      amount: hingeTotal * p.hinge,
    });
    if (handleCount > 0) {
      items.push({
        label: "Kulp",
        detail: `${handleCount} adet`,
        amount: handleCount * p.handle,
      });
    }
  }
  items.push({
    label: "CNC İşçilik & Kesim",
    detail: `${totalProcessArea.toFixed(2)} m²`,
    amount: totalProcessArea * p.cncRate,
    hidden: true,
  });
  if ((cfg.drawers ?? 0) > 0) {
    const drawerCount = cfg.drawers * ((cfg.dividers ?? 0) + 1);
    items.push({
      label: "Çekmece Rayı & Aksesuar",
      detail: `${drawerCount} adet • yükseklik ${cfg.drawerHeight ?? 20} cm`,
      amount: drawerCount * (p.drawerRail ?? 120),
    });
  }
  if (cfg.base === "ayak") {
    items.push({
      label: "Dolap Ayağı",
      detail: "4 adet • +10 cm yükseklik",
      amount: 4 * (p.legUnit ?? 35),
    });
  }

  items.forEach((i) => (i.amount = Math.round(i.amount)));
  const total = items.reduce((s, i) => s + i.amount, 0);
  return { items, total };
}

// Shelf-based (FFDH) nesting. Body panels on 280x210 sheets; door panels on
// 280x122 sheets when the door material is akrilik/highgloss, else 280x210.
export function computeCnc(cfg) {
  const bodySheet = { w: SHEET_W, h: SHEET_H }; // 280 x 210
  const doorSmall = cfg.doorMaterial === "akrilik" || cfg.doorMaterial === "highgloss";
  const doorSheet = doorSmall ? { w: 280, h: 122 } : { w: SHEET_W, h: SHEET_H };

  const allPanels = buildPanels(cfg);
  const glassPanels = allPanels.filter((p) => p.nocut && p.nocutType !== "ayna"); // cam kapaklar tabaka kesimine girmez
  const mirrorPanels = allPanels.filter((p) => p.nocutType === "ayna"); // ayna kapaklar da kesime girmez
  const cutPanels = allPanels.filter((p) => !p.nocut);
  const bodyPanels = cutPanels.filter((p) => p.group !== "door");
  const doorPanels = cutPanels.filter((p) => p.group === "door");

  function packGroup(panels, dim, groupName) {
    // En büyük alandan küçüğe sırala; serbest-dikdörtgen (guillotine) yerleşim:
    // her parça yatay + dikey yönde tüm boş alanlara denenir, en az fire bırakana oturur.
    const sorted = [...panels].sort((a, b) => b.w * b.h - a.w * a.h);
    const sheets = [];
    const newSheet = () => {
      const s = {
        w: dim.w,
        h: dim.h,
        group: groupName,
        placements: [],
        free: [{ x: 0, y: 0, w: dim.w, h: dim.h }],
      };
      sheets.push(s);
      return s;
    };
    newSheet();
    const unplaced = [];

    const tryPlace = (s, panel) => {
      let best = null;
      for (const r of s.free) {
        for (const [pw, ph] of [
          [panel.w, panel.h],
          [panel.h, panel.w],
        ]) {
          if (pw <= r.w + 0.001 && ph <= r.h + 0.001) {
            const waste = Math.min(r.w - pw, r.h - ph);
            if (!best || waste < best.waste) best = { r, pw, ph, waste };
          }
        }
      }
      if (!best) return false;
      const { r, pw, ph } = best;
      s.placements.push({ x: r.x, y: r.y, w: pw, h: ph, name: panel.name, color: panel.color });
      s.free = s.free.filter((f) => f !== r);
      // Guillotine split: sağ kalan (parça yüksekliğinde) + alt kalan (tam genişlik)
      if (r.w - pw > 0.001) s.free.push({ x: r.x + pw, y: r.y, w: r.w - pw, h: ph });
      if (r.h - ph > 0.001) s.free.push({ x: r.x, y: r.y + ph, w: r.w, h: r.h - ph });
      return true;
    };

    sorted.forEach((panel) => {
      // Her iki yönde de tabakaya sığmıyorsa yan tarafta ayrı gösterilir
      const fits = (panel.w <= dim.w && panel.h <= dim.h) || (panel.h <= dim.w && panel.w <= dim.h);
      if (!fits) {
        unplaced.push(panel);
        return;
      }
      // Önceki tabakalar tamamen dolmadan yeni tabakaya geçme
      for (const s of sheets) {
        if (tryPlace(s, panel)) return;
      }
      const s = newSheet();
      tryPlace(s, panel);
    });
    return { sheets, unplaced };
  }

  // Gövde ve kapak malzemesi+rengi aynıysa tüm parçalar tek tabaka grubunda yerleşir
  const combined =
    !cfg.doorless && cfg.bodyMaterial === cfg.doorMaterial && cfg.bodyColor === cfg.doorColor;
  const bodyRes = combined
    ? packGroup(allPanels, bodySheet, "mixed")
    : packGroup(bodyPanels, bodySheet, "body");
  const doorRes =
    !combined && doorPanels.length > 0
      ? packGroup(doorPanels, doorSheet, "door")
      : { sheets: [], unplaced: [] };
  const sheets = [...bodyRes.sheets, ...doorRes.sheets];
  const unplaced = [...bodyRes.unplaced, ...doorRes.unplaced];

  const usedAreaM2 = cutPanels.reduce((s, p) => s + areaM2(p.w, p.h), 0) - unplaced.reduce((s, p) => s + areaM2(p.w, p.h), 0);
  const totalSheetArea = sheets.reduce((s, sh) => s + areaM2(sh.w, sh.h), 0);
  const firePercent = totalSheetArea > 0 ? ((totalSheetArea - usedAreaM2) / totalSheetArea) * 100 : 0;
  const cutLengthM = cutPanels.reduce((s, p) => s + (2 * (p.w + p.h)) / 100, 0);

  return {
    combined,
    sheets: sheets.map((s) => ({ w: s.w, h: s.h, group: s.group, placements: s.placements })),
    unplaced: unplaced.map((p) => ({ name: p.name, w: +p.w.toFixed(1), h: +p.h.toFixed(1), color: p.color })),
    sheetCount: sheets.length,
    bodySheetCount: bodyRes.sheets.length,
    doorSheetCount: doorRes.sheets.length,
    doorSheetW: doorSheet.w,
    doorSheetH: doorSheet.h,
    sheetW: SHEET_W,
    sheetH: SHEET_H,
    usedAreaM2: +usedAreaM2.toFixed(2),
    sheetAreaM2: +areaM2(SHEET_W, SHEET_H).toFixed(2),
    firePercent: +firePercent.toFixed(1),
    cutLengthM: +cutLengthM.toFixed(1),
    glassPanels: glassPanels.map((p) => ({
      name: p.name,
      w: +p.w.toFixed(1),
      h: +p.h.toFixed(1),
      glassW: +(p.w - 9).toFixed(1), // 4.5 cm alüminyum çerçeve her kenardan
      glassH: +(p.h - 9).toFixed(1),
    })),
    glassCount: glassPanels.length,
    mirrorPanels: mirrorPanels.map((p) => ({
      name: p.name,
      w: +p.w.toFixed(1),
      h: +p.h.toFixed(1),
    })),
    mirrorCount: mirrorPanels.length,
    partCount: cutPanels.length,
  };
}

export function formatTRY(n) {
  return new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    maximumFractionDigits: 0,
  }).format(n || 0);
}

export const STATUS_META = {
  ödeme_bekliyor: { label: "Ödeme Bekliyor", color: "#64748B", bg: "#E2E8F0" },
  hazırlanıyor: { label: "Hazırlanıyor", color: "#F59E0B", bg: "#FEF3C7" },
  üretimde: { label: "Üretimde", color: "#3B82F6", bg: "#DBEAFE" },
  kargoda: { label: "Kargoda", color: "#8B5CF6", bg: "#EDE9FE" },
  teslim_edildi: { label: "Teslim Edildi", color: "#10B981", bg: "#D1FAE5" },
  iptal: { label: "İptal Edildi", color: "#DC2626", bg: "#FEE2E2" },
};

export const STATUS_ORDER = ["hazırlanıyor", "üretimde", "kargoda", "teslim_edildi", "iptal"];
